/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FileWorkflowSummary { 
    id: string;
    name?: string;
    status: FileWorkflowSummary.StatusEnum;
    currentStepOrder: number;
    totalSteps: number;
}
export namespace FileWorkflowSummary {
    export type StatusEnum = 'pending' | 'in_progress' | 'completed' | 'rejected' | 'cancelled';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        InProgress: 'in_progress' as StatusEnum,
        Completed: 'completed' as StatusEnum,
        Rejected: 'rejected' as StatusEnum,
        Cancelled: 'cancelled' as StatusEnum
    };
}


